function Header({ children }) {
    return (
        <div className="header-wrapper">
            <h2 className="Header">{children}</h2>
            <br />
        </div>
    )
}

export default Header